import { DocumentStatus } from 'services/documents/entities';

export const ApprovalButtonVariant = {
  SHARE: 'SHARE',
  REQUEST_APPROVAL: 'REQUEST_APPROVAL',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  APPROVE_REQUEST: 'APPROVE_REQUEST',
} as const;

export type ApprovalButtonVariant = (typeof ApprovalButtonVariant)[keyof typeof ApprovalButtonVariant];

interface GetApprovalButtonVariantParams {
  status: DocumentStatus;
  requiresApproval: boolean;
  canApprove: boolean;
}

export function getApprovalButtonVariant({ status, requiresApproval, canApprove }: GetApprovalButtonVariantParams): ApprovalButtonVariant {
  if (status === DocumentStatus.AWAITING_APPROVAL && canApprove) return ApprovalButtonVariant.APPROVE_REQUEST;

  if (requiresApproval) {
    if (status === DocumentStatus.DRAFT) return ApprovalButtonVariant.REQUEST_APPROVAL;
    if (status === DocumentStatus.AWAITING_APPROVAL) return ApprovalButtonVariant.AWAITING_APPROVAL;
    return ApprovalButtonVariant.SHARE;
  }

  return ApprovalButtonVariant.SHARE;
}
